<template>
  <!-- <f7-page class="EditAccountMember"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Member details" popoverName=".popoverMembers" ReturnButton></page-nav-bar>
      <div class="layoutTop"/>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-10 offset-md-1 ">
          <div class="panel21 panel-default">
            <form>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Login</label>
                <div class="col-7 col-sm-10">
                  <input type="text" class="form-control" v-model="login" readonly>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Request to Pay</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" name="clearance_payments" type="text" placeholder="" v-if="clearance_payments === '1'" value="Administrator" disabled></input>
                  <input class="form-control" name="clearance_payments" type="text" placeholder="" v-if="clearance_payments === '3'" value="User" disabled></input>
                  <input class="form-control" name="clearance_payments" type="text" placeholder="" v-if="clearance_payments === '0'" value="No Access" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Modular Credit</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" name="clearance_directDebit" type="text" placeholder="" v-if="clearance_directDebit === '1'" value="Administrator" disabled></input>
                  <input class="form-control" name="clearance_directDebit" type="text" placeholder="" v-if="clearance_directDebit === '3'" value="User" disabled></input>
                  <input class="form-control" name="clearance_directDebit" type="text" placeholder="" v-if="clearance_directDebit === '0'" value="No Access" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Direct Payments</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" name="clearance_directPayments" type="text" placeholder="" v-if="clearance_directPayments === '1'" value="Administrator" disabled></input>
                  <input class="form-control" name="clearance_directPayments" type="text" placeholder="" v-if="clearance_directPayments === '3'" value="User" disabled></input>
                  <input class="form-control" name="clearance_directPayments" type="text" placeholder="" v-if="clearance_directPayments === '0'" value="No Access" disabled></input>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="row justify-content-start" :class="colorBottomButton">
        <div class="offset-md-5 col-md-3">
          <a href="/accountMembers/edit/" style="color: #000;">
            <button round class="button-action firstButtonMarginTop">
              <f7-icon f7="edit"></f7-icon>
              <span>Edit</span>
            </button>
          </a>
        </div>
        <div class="col-md-3">
          <button round
          class="button-action firstButtonMarginTop"
          @click="removeAccountMember">
            <f7-icon f7="close_round_fill"></f7-icon>
            <span>Remove</span>
          </button>
        </div>
      </div>
    </div>

    <div class="toolbarPageBottomBlank"></div>
  <!-- </f7-page> -->
    </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AccountMemberDetail',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      login: '',
      status: '',
      clearance_payments: '0',
      clearance_directDebit: '0',
      clearance_directPayments: '0'
    }
  },
  created () {
    this.login = this.$settings.currentAccountMember.login
    this.clearance_payments = this.$settings.currentAccountMember.clearance_payments
    this.clearance_directDebit = this.$settings.currentAccountMember.clearance_directDebit
    this.clearance_directPayments = this.$settings.currentAccountMember.clearance_directPayments
  },
  methods: {
    removeAccountMember () {
      let that = this
      that.$f7.confirm('Are you sure to delete this account member?', 'Operation confirmation', function () {
        that.$engine.accounts
        .deleteUserFromAccount(that.$settings.currentAccountMember.id)
        .then(resp => {
          that.$f7.modal({
            title: 'Account deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.login = ''
            that.$f7.closeModal()
            // that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMAccountMemberDetail.vue?7c00189a